import { OrderStatus } from '@dss-libs/shared/type/common-types';

const ORDER_STATUS_COLOR_MAP = new Map<OrderStatus, string>([
  [OrderStatus.Completed, 'var(--color-success-hover)'],
  [OrderStatus.Pending, 'var(--color-warning)'],
  [OrderStatus.InProgress, 'var(--color-primary)'],
  [OrderStatus.Expired, 'var(--color-danger-hover)'],
  [OrderStatus.Declined, 'var(--color-danger-hover)'],
  [OrderStatus.Cancelled, 'var(--color-danger-hover)'],
]);

export const getOrderStatusColor = (orderStatus: OrderStatus): string =>
  ORDER_STATUS_COLOR_MAP.get(orderStatus) ?? 'var(--color-ink)';

const ORDER_STATUS_HOVER_MAP = new Map<OrderStatus, string>([
  [OrderStatus.Completed, 'hover:bg-success-surface'],
  [OrderStatus.Pending, 'hover:bg-primary-ghost'],
  [OrderStatus.InProgress, 'hover:bg-primary-ghost'],
  [OrderStatus.Expired, 'hover:bg-danger-surface'],
  [OrderStatus.Declined, 'hover:bg-danger-surface'],
  [OrderStatus.Cancelled, 'hover:bg-danger-surface'],
]);

export const getOrderStatusOnHoverClasses = (orderStatus: OrderStatus): string =>
  ORDER_STATUS_HOVER_MAP.get(orderStatus) ?? 'hover:bg-primary-ghost';
